namespace TabAurous.FormatHelper {

    export function GetFormat(FormatType: string, BranchCode: string) {

        var Format: string;
        // var Test: OMS.CommonAttributesRow
        let ServiceEndpoint = "/services/" + TabAurous.Common.FormatHelperService.baseUrl + "/GetFormat"

        $.ajax({
            type: "post",
            dataType: "json",
            async: false,
            url: ServiceEndpoint,
            data: {
                'FormatType': FormatType,
                'BranchCode': BranchCode
            },
            success: function (response) {

                if (response instanceof Object) {
                    var json = response;
                }
                else {
                    var json = $.parseJSON(response);
                }

                var output = json['result'];
                Format = output;
            }.bind(this),
            error: function (jqxhr, textStatus, error) {
                var err = textStatus + ", " + error;
                alert("Error! " + err);
            }

        });

        return Format;

    }

    export function GetVoucherNo(VoucherTypeId: number) {
        let now = new Date();
        var DD = now.getDay();
        var MM = now.getUTCMonth() + 1;
        var YY = now.getFullYear().toString().substr(-2);
        var MON = now.toLocaleString('default', { month: 'short' });
        var YYYY = now.getUTCFullYear()
        var hr = now.getUTCHours();
        var mn = now.getUTCMinutes();
        var sc = now.getUTCSeconds();

        var number: string;
        var dateFormat: string;
        var VoucherDetails = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == VoucherTypeId)[0];

        if (VoucherDetails.BranchWise) {
            number = Q.Authorization.userDefinition.CompanyCode + VoucherDetails.Separator;
        }

        if (number != undefined)
            number = number + VoucherDetails.Prefix + VoucherDetails.Separator;
        else
            number = VoucherDetails.Prefix + VoucherDetails.Separator;

        switch (VoucherDetails.PrefixDate) {
            case "[MM]/[YY]":
                dateFormat = pad(MM, 2) + VoucherDetails.Separator + YY + VoucherDetails.Separator
                break;
            case "[MM]/[YYYY]":
                dateFormat = MM + VoucherDetails.Separator + YYYY + VoucherDetails.Separator
                break;
            case "[MON]/[YYYY]":
                dateFormat = MON.toLocaleUpperCase() + VoucherDetails.Separator + YY + VoucherDetails.Separator
                break;
            case "[YY]":
                dateFormat = YY + VoucherDetails.Separator
                break;
            case "[YYYY]":
                dateFormat = YYYY + VoucherDetails.Separator
                break;
        }

        var uid = VoucherDetails.LastNumber + VoucherDetails.IncrementBy;

        //uid = pad1(uid, 5);

        var VoucherNo = number + dateFormat + pad(uid, 5);

        return VoucherNo;
    }



    export function GetFormats(FormatType: string) {
        let now = new Date();
        var MM = now.getUTCMonth() + 1;
        var YY = now.getFullYear().toString().substr(-2);
        var MON = now.toLocaleString('default', { month: 'short' });
        var YYYY = now.getUTCFullYear()

        Q.reloadLookup('OMS.FormatMaster');

        var number: string;
        var dateFormat = "";
        
        var FormatDetails = OMS.FormatMasterRow.getLookup().items.filter(x => x.FormatType == FormatType)[0];

        if (FormatDetails != undefined) {
            if (FormatDetails.Prefix == undefined)
                FormatDetails.Prefix = "";
            if (FormatDetails.Separator == undefined)
                FormatDetails.Separator = "";
            if (FormatDetails.Noofzeroes == undefined)
                FormatDetails.Noofzeroes = 0;

            if (FormatDetails.BranchWise) {
                number = pad(Q.Authorization.userDefinition.CompanyId, 2) + FormatDetails.Separator;
            }
 
            if (number != undefined)
                number = number + FormatDetails.Prefix + FormatDetails.Separator;
            else
                number = FormatDetails.Prefix + FormatDetails.Separator;

            switch (FormatDetails.PrefixDate) {
                case "[MM]/[YY]":
                    dateFormat = pad(MM, 2) + FormatDetails.Separator + YY + FormatDetails.Separator
                    break;
                case "[MM]/[YYYY]":
                    dateFormat = MM + FormatDetails.Separator + YYYY + FormatDetails.Separator
                    break;
                case "[MON]/[YYYY]":
                    dateFormat = MON.toLocaleUpperCase() + FormatDetails.Separator + YY + FormatDetails.Separator
                    break;
                case "[YY]":
                    dateFormat = YY + FormatDetails.Separator
                    break;
                case "[YYYY]":
                    dateFormat = YYYY + FormatDetails.Separator
                    break;
                case "[MM][YY]":
                    dateFormat = MM.toString() + YY.toString() + FormatDetails.Separator
                    break;
                case "[MM][YYYY]":
                    dateFormat = MM.toString() + YYYY.toString() + FormatDetails.Separator
                    break;
                default:
                    dateFormat = ""
                    break;
            }

            if (FormatDetails.ResetMonthly && MM != FormatDetails.LastMonth) {
                FormatDetails.LastNumber = 0;
                FormatDetails.LastMonth = MM;
            }

            if (FormatDetails.ResetYearly && YYYY != FormatDetails.LastYear) {
                FormatDetails.LastNumber = 0;
                FormatDetails.LastYear = YYYY;
            }

            var uid = FormatDetails.LastNumber + FormatDetails.IncrementBy;

        }
        var Format = number + dateFormat + pad(uid, FormatDetails.Noofzeroes);

        var NewFormat: OMS.FormatMasterRow = {
            FormatId: FormatDetails.FormatId,
            LastNumber: uid,
            LastMonth: FormatDetails.LastMonth,
            LastYear: FormatDetails.LastYear

        }
        OMS.FormatMasterService.Update(
            {
                Entity: NewFormat,
                EntityId: FormatDetails.FormatId,
            }, response => { }, { async: false })

        return Format;
    }


    function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }
}

